import { isDev } from 'embed/constants/config'
import Parent from 'common/services/Parent'
import { GoogleAnalyticsEvent, GoogleAnalyticsEventTypes, GoogleAnalyticsPageview } from 'even-ts-static'
export interface GoogleAnalyticDebug {
  trace: boolean
}

declare global {
  interface Window {
    ga_debug: GoogleAnalyticDebug
    fbq?: (fbEventType: string, eventName: string, data?: object | undefined) => Promise<unknown>
  }
}

export class GoogleAnalayticsService {
  client?: UniversalAnalytics.ga
  publishToParent = false

  constructor() {
    if (typeof ga !== 'undefined') {
      this.client = ga
    }

    // If in development, prevent hits from being sent to Google Analaytics (but logged to console)
    if (isDev && this.client !== undefined) {
      ga('set', 'sendHitTask', null)

      // Use the line below to increase logging of GA events, helpful when checking the values of new events
      // window.ga_debug = { trace: true }
    }
  }

  sendEvent = (event: GoogleAnalyticsEvent) => {
    if (this.client !== undefined) {
      this.client(
        'set',
        {
          page: event.path,
          title: event.title,
        },
        { ...event.fields },
      )

      this.client('send', 'event', event.category, event.action, event.label, event.count, {
        ...event.fields,
      })
    }

    if (this.publishToParent === true) {
      Parent.publishMessage(GoogleAnalyticsEventTypes.Event, event)
    }
  }

  sendPageview = (pageview: GoogleAnalyticsPageview) => {
    if (this.client !== undefined) {
      this.client(
        'set',
        {
          page: pageview.path,
          title: pageview.title,
        },
        { ...pageview.fields },
      )
      this.client('send', 'pageview')
    }

    if (this.publishToParent === true) {
      Parent.publishMessage(GoogleAnalyticsEventTypes.Pageview, pageview)
    }
  }
}

export default new GoogleAnalayticsService()
